<template>
  <div class="box">
    <!-- 头部 -->
    <headers></headers>
    <el-carousel :interval="3000">
      <el-carousel-item>
        <img src="@/assets/homePage/新闻资讯banner.png" class="images">
      </el-carousel-item>
      <el-carousel-item>
        <img src="@/assets/homePage/视频banner.png" class="images">
      </el-carousel-item>
    </el-carousel>
    <!-- 内容区域 -->
    <div class="content_top">
      <div class="b_1">
        <span v-for="item in video_list" :key="item.id" :class="{videoClass:item.id == video_id}"
          style="margin-right: 20px;" @click="videoSpan(item.id)">
          {{item.title}}
        </span>
      </div>
    </div>
    <div class="content" v-show="video_id==1">
      <div class="content_1" v-for="item in dataList" :key="item.id" @click="routePush(item.id)">
        <div>
          <img :src="item.url" class="imgs" />
        </div>
        <p style="font-size: 1.1rem;">{{ item.name }}</p>
        <div class="box" style="margin-left: 1.3rem;color:#777;">{{ item.date }}</div>
      </div>
    </div>
    <div class="page_data">
      <el-pagination background style="margin-left: 50%;transform: translateX(-50%);" v-model:currentPage="currentPage"
        v-show="video_id==1" v-model:page-size="pageSize" :page-sizes="[9, 18, 27, 36]" :disabled="disabled"
        layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :default-page-size="12" />
    </div>
    <div class="content_button" v-show="video_id==2">
      <div class="video" v-for="item in video_data" :key="item.id">
        <video controls controlslist="nodownload" oncontextmenu="return false">
          <source :src="item.url" type="video/mp4">
        </video>
        <h2>{{item.name}}</h2>
        <p>{{item.title}}</p>
      </div>
    </div>
    <!-- 底部 -->
    <foot></foot>
  </div>
  <div class="_div">
    <!-- 头部 -->
    <move_header></move_header>
    <!-- 轮播图 -->
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <img src="@/assets/homePage/新闻资讯banner.png" style="width: 100%;">
      </van-swipe-item>
      <van-swipe-item>
        <img src="@/assets/homePage/视频banner.png" style="width: 100%;">
      </van-swipe-item>
    </van-swipe>
    <!-- 中间内容区域 -->
    <div class="table_T">
        <span v-for="item in video_list" :key="item.id" :class="{videoClass:item.id == video_id}"
          style="margin-right: 20px;" @click="videoSpan(item.id)">
          {{item.title}}
        </span>
    </div>
    <div class="content" v-show="video_id==1">
      <div class="box_center" v-for="item in move_dataList" :key="item.id" @click="routePush(item.id)">
        <img :src="item.url" alt="">
        <div class="pp">
          <p style="font-size: 2.5rem;">{{ item.name }}</p>
          <p class="p_2">{{ item.date }}</p>
        </div>
      </div>
    </div>
    <div class="content_button" v-show="video_id==2">
      <div class="video" v-for="item in video_data" :key="item.id">
        <video controls controlslist="nodownload" οncοntextmenu="return false">
          <source :src="item.url" type="video/mp4">
        </video>
        <h2>{{item.name}}</h2>
        <p>{{item.title}}</p>
      </div>
    </div>
    <!-- 底部 -->
    <move_foot></move_foot>
  </div>
</template>

<script>
import foot from "../components/foot.vue";
import headers from "../components/header.vue";
import { reactive, toRefs, onMounted, ref } from "vue";
import move_foot from "../move_components/move_foot.vue";
import move_header from "../move_components/move_header.vue";
import { useRouter, useRoute } from 'vue-router' //引入useRouter
import { debounce } from '@/utils/debounce.js'
export default {
  components: { foot, headers, move_foot, move_header },

  setup() {
    const router = useRouter()
    const route = useRoute()
    const currentPage = ref(null)//当前页数
    const move_currentPage = ref(null)//当前页数
    const pageSize = ref(9) //当前页展示个数
    const move_pageSize = ref(8) //当前页展示个数
    const total = ref(null) //总数 
    const state = reactive({
      _dataList: [
        { id: 0,  date: '', name: '盛泰有约·家庭趣欢享||家庭开放日活动', url: require('@/assets/news/小图/0.png') },

        //{id:135,date:"2024年12月x日",name:"喜讯|xx获得亚洲区XX奖",url: require('@/assets/news/小图/135.png')},
        {id:148,date:"2025年3月31日",name:"光影同欢，生辰同贺——2025年一季度生日员工集体观影活动圆满结束",url: require('@/assets/news/小图/148.png')},
        {id:147,date:"2025年3月14日",name:"植树添绿，共建美好园区",url: require('@/assets/news/小图/147.png')},
        {id:146,date:"2025年3月13日",name:"江津区区委书记唐大军率队莅临盛泰考察调研，加强两地交流互动、拓宽合作领域",url: require('@/assets/news/小图/146.png')},
        {id:145,date:"2025年3月10日",name:"美好时光，快乐采摘——2025年38女神节户外采摘活动圆满结束",url: require('@/assets/news/小图/145.png')},

        {id:144,date:"2025年2月18日",name:"盛泰光电2025届大学生岗前培训结业，人才培育再结硕果",url: require('@/assets/news/小图/144.png')},
        {id:143,date:"2025年2月14日",name:"灯火映团圆，欢乐度元宵”——盛泰光电举办趣味活动共度元宵佳节",url: require('@/assets/news/小图/143.png')},
        {id:142,date:"2025年1月18日",name:"乘势而上谱新篇，同心协力创辉煌”盛泰光电2025公司年会圆满落幕",url: require('@/assets/news/小图/142.png')},
        {id:141,date:"2025年1月10日",name:"创新成果“亮剑”，发展引擎劲燃——公司首届技术论坛决赛顺利收官",url: require('@/assets/news/小图/141.png')},
        {id:140,date:"2024年12月19日",name:"探技术深境，于论坛畅行；汇百家卓见，燃创新繁星——2024年盛泰举办首届技术论坛预选赛",url: require('@/assets/news/小图/140.png')},
        {id:139,date:"2024年12月17日",name:"中国中小企业国际合作协会深入盛泰光电调研，共探产教融合新路径",url: require('@/assets/news/小图/139.png')},
        {id:138,date:"2024年12月11日",name:"喜讯|盛泰光电笔电摄像头模组荣获2024年重庆市制造业单项冠军",url: require('@/assets/news/小图/138.png')},
        {id:137,date:"2024年12月7日",name:"喜报 | 盛泰光电荣膺“重庆市企业技术中心”称号",url: require('@/assets/news/小图/137.png')},
        {id:136,date:"2024年12月3日",name:"圈友相聚展实力、继往开来谱新篇——2024年QCC品质圈活动圆满完成",url: require('@/assets/news/小图/136.png')},
        {id:135,date:"2024年12月3日",name:"关爱员工，健康同行——2024全员健康体检",url: require('@/assets/news/小图/135.png')},
        {id:134,date:"2024年12月2日",name:"喜讯|盛泰光电荣获大足区2023年度科技型企业研发投入第二名",url: require('@/assets/news/小图/134.png')},
        {id:133,date:"2024年12月2日",name:"喜讯|盛泰光电荣获“双百企业”奖项",url: require('@/assets/news/小图/133.png')},
        {id:132,date:"2024年11月27日",name:"大足区委组织部（老干部局）组织离退休干部到盛泰光电参观调研",url: require('@/assets/news/小图/132.png')},
        {id:131,date:"2024年11月25日",name:"同心同行同成长，携手共进创未来|人力资源部举行2024年第三期IDL座谈会",url: require('@/assets/news/小图/131.png')},
        {id:130,date:"2024年11月23日",name:"训有所成，试有所展，教有所长——2024年内部讲师培训圆满结束",url: require('@/assets/news/小图/130.png')},
        {id:129,date:"2024年11月23日",name:"篮球风暴·梦想起航——2024盛泰光电冬季篮球赛圆满收官",url: require('@/assets/news/小图/129.png')},
        {id:128,date:"2024年11月13日",name:"“喜讯|盛泰光电荣膺2024年高新技术企业认证",url: require('@/assets/news/小图/128.png')},
        {id:127,date:"2024年11月1日",name:"重庆市经济和信息化委员会党组书记、主任王志杰一行莅临我司开展调研工作",url: require('@/assets/news/小图/127.png')},


        {id:126,date:"2024年10月28日",name:"喜讯丨盛泰光电荣获2024年度智能摄像头检测技术知识产权保护示范创建项目",url: require('@/assets/news/小图/126.png')},
        {id:125,date:"2024年10月28日",name:"运营部中连线专案报告大会圆满结束",url: require('@/assets/news/小图/125.png')},
        {id:124,date:"2024年10月28日",name:"廊桥通途，便捷启航 —— 打造更贴心的员工通行环境",url: require('@/assets/news/小图/124.png')},
        {id:123,date:"2024年10月24日",name:"“秋风启航越山海,盛泰之星逐梦行 ”2024年第三季度盛泰之星颁奖典礼圆满落幕",url: require('@/assets/news/小图/123.png')},
        {id:122,date:"2024年10月9日",name:"盛泰光电科技股份有限公司荣获2024年重庆市制造业单项冠军",url: require('@/assets/news/小图/122.png')},

        {id:121,date:"2024年9月27日",name:"盛泰光电成功举行2024年下半年消防安全演练——强化安全意识，共创平安厂区",url: require('@/assets/news/小图/121.png')},
        {id:120,date:"2024年9月27日",name:"双喜临门‖盛泰光电荣膺2024重庆制造业百强与重庆市企业创新奖",url: require('@/assets/news/小图/120.png')},
        {id:119,date:"2024年9月26日",name:"红花背后是绿叶 ——致岗位技能大赛的裁判组人员",url: require('@/assets/news/小图/119.png')},
        {id:118,date:"2024年9月23日",name:"匠心筑梦，技胜未来 | 2024年岗位技能大赛圆满结束",url: require('@/assets/news/小图/118.png')},
        {id:117,date:"2024年9月14日",name:"月圆人团圆，趣玩中秋夜",url: require('@/assets/news/小图/117.png')},

        {id:113,date:"2024年8月30日",name:"慰问优秀高考学子，温情关怀暖人心",url: require('@/assets/news/小图/113.png')},
        {id:112,date:"2024年8月23日",name:"推进企业数字化转型升级 构建新质生产力发展",url: require('@/assets/news/小图/112.png')},
        {id:116,date:"2024年8月17日",name:"匠心筑梦，技胜未来，2024年岗位技能大赛动员大会正式拉开比赛序幕！",url: require('@/assets/news/小图/116.png')},
        {id:114,date:"2024年8月16日",name:"《2024年重庆市智能工厂名单》正式公布，盛泰光电入选！",url: require('@/assets/news/小图/114.png')},
        {id:115,date:"2024年8月16日",name:"凝“新”聚力，扬帆远航——2024年第二期IDL员工座谈会圆满结束",url: require('@/assets/news/小图/115.png')},


        {id:111,date:"2024年8月1日",name:"盛泰光电携手“红岩先锋”，以实际行动助力乡村振兴",url: require('@/assets/news/小图/111.png')},
        {id:110,date:"2024年7月31日",name:"“益”托安心，快乐同行——2024年暑期爱心公益托管班开启守护计划",url: require('@/assets/news/小图/110.png')},
        {id:109,date:"2024年7月29日",name:"爱拼才会赢，乒乓球比赛精彩纷呈",url: require('@/assets/news/小图/109.png')},
        {id:108,date:"2024年7月19日",name:"荣誉加冕，致敬精英，共绘蓝图！",url: require('@/assets/news/小图/108.png')},
        {id:107,date:"2024年7月12日",name:"无偿献血我先行 爱心传递勇担当",url: require('@/assets/news/小图/107.png')},
        {id:106,date:"2024年7月8日",name:"激扬时代韶华，共聚青春力量——2024年第二期大学生岗前培训结业仪式",url: require('@/assets/news/小图/106.png')},
        {id:105,date:"2024年7月3日",name:"绿色行动，从我做起——共建节约型企业环境",url: require('@/assets/news/小图/105.png')},
        {id:104,date:"2024年7月2日",name:"盛泰光电2024上半年消防安全演练圆满成功",url: require('@/assets/news/小图/104.png')},
        
        {id:103,date:"2024年6月22日",name:"盛泰光电与极米科技深化战略合作，共绘未来智能视界新蓝图",url: require('@/assets/news/小图/103.png')},
        {id:102,date:"2024年6月6日",name:"浓情端午·共庆生辰",url: require('@/assets/news/小图/102.png')},

        {id:101,date:"2024年5月28日",name:"创新突破稳定品质，落实管理提高效率——2024年盛泰光电六西格玛终期评审工作落幕",url: require('@/assets/news/小图/101.png')},
        {id:100,date:"2024年5月28日",name:"盛泰光电携产品参加第六届中国西部国际投资贸易洽谈会",url: require('@/assets/news/小图/100.png')},
        {id:99,date:"2024年5月15日",name:"盛泰光电第三届钓王大赛圆满结束",url: require('@/assets/news/小图/99.png')},

        {id:98,date:"2024年4月27日",name:"坚持预防为主，守护职业健康 | 盛泰光电荣获“重庆市健康企业”荣誉称号",url: require('@/assets/news/小图/98.png')},
        {id:97,date:"2024年4月15日",name:"绿色行动 · 守护五档山——盛泰光电公益行活动圆满",url: require('@/assets/news/小图/97.png')},
        {id:96,date:"2024年4月3日",name:"西婵小学小记者走进盛泰光电，探寻新时代科技企业发展之路",url: require('@/assets/news/小图/96.png')},
        {id:95,date:"2024年4月2日",name:"千里驰援，盛泰支援队用实际行动践行企业使命",url: require('@/assets/news/小图/95.png')},
        {id:94,date:"2024年4月2日",name:"盛泰光电入选2023年度市级工业设计中心名单",url: require('@/assets/news/小图/94.png')},


        {id:93,date:"2024年3月25日",name:"春暖三月，筝筝日上||盛泰光电2-3月员工生日会圆满举行",url: require('@/assets/news/小图/93.png')},
        {id:92,date:"2024年3月20日",name:"2024盛泰大讲堂《以客户为导向的企业战略与运营管理》",url: require('@/assets/news/小图/92.png')},
        {id:91,date:"2024年3月1日",name:"农业银行重庆分行领导一行莅临盛泰光电参观指导",url: require('@/assets/news/小图/91.png')},
        {id:90,date:"2024年2月26日",name:"共同书写携手并进、合作共赢的高质量发展新篇章|眉山市洪雅县党政代表团来盛泰考察",url: require('@/assets/news/小图/90.png')},
        {id:88,date:"2024年2月7日",name:"岁末寒冬送温暖 关心关爱暖人心",url: require('@/assets/news/小图/88.png')},
   
        {id:85,date:"2023年12月19日",name:"消防“零”距离，安全记在心！盛泰光电开展2023年下半年消防演练",url: require('@/assets/news/小图/85.png')},
        {id:84,date:"2023年12月5日",name:"袁家军在盛泰光电调研时强调 更好服务企业服务群众 以主题教育成效推动高质量发展",url: require('@/assets/news/小图/84.png')},
        {id:83,date:"2023年12月1日",name:"国家级《2023年5G工厂名录》公布，盛泰光电入选！",url: require('@/assets/news/小图/83.png')},
        {id:82,date:"2023年11月24日",name:"广东深圳先进材料企业考察团一行莅临盛泰光电参观交流",url: require('@/assets/news/小图/82.png')},
        {id:81,date:"2023年11月20日",name:"拥抱自然，幸福采摘|员工生日采摘活动",url: require('@/assets/news/小图/81.png')},
        {id:80,date:"2023年11月13日",name:"为爱同行，徒步公益行|盛泰光电徒步活动圆满结束",url: require('@/assets/news/小图/80.png')},
        {id:79,date:"2023年11月1日",name:"力拔山河，绳彩飞扬，2023年盛泰光电拔河比赛圆满结束",url: require('@/assets/news/小图/79.png')},
        {id:78,date:"2023年10月31日",name:"传递爱心，传承知识，盛泰光电图书角正式开放啦！",url: require('@/assets/news/小图/78.png')},
        {id:76,date:"2023年10月16日",name:"突破是成功的前奏，方法是成功的利器",url: require('@/assets/news/小图/76.png')},
        {id:75,date:"2023年9月20日",name:"恭喜！盛泰光电公司荣获第六届“绽放杯”5G应用征集大赛重庆区域赛二等奖",url: require('@/assets/news/小图/75.png')},
        {id:74,date:"2023年9月13日",name:"盛泰光电科技股份有限公司入选重庆市企业创新奖！",url: require('@/assets/news/小图/74.png')},
        {id:73,date:"2023年9月8日",name:"踢出风采，赛出友谊|2023年盛泰光电首届足球赛圆满落幕",url: require('@/assets/news/小图/73.png')},
        {id:72,date:"2023年9月6日",name:"盛泰光电荣获工信部2022年国家级智能制造优秀场景",url: require('@/assets/news/小图/72.png')},
        {id:71,date:"2023年8月31日",name:"怦然“新”动，筑梦未来——2023年盛泰光电新员工欢迎会",url: require('@/assets/news/小图/71.png')},
        {id:70,date:"2023年8月30日",name:"盛泰光电公司荣获2022年度大足区特色产业高地建设先进集体",url: require('@/assets/news/小图/70.png')},
        {id:69,date:"2023年7月31日",name:"与你相约，光影共赏，7月生日员工观影活动圆满结束",url: require('@/assets/news/小图/69.png')},
        {id:68,date:"2023年7月13日",name:"互信共荣，合力同辉——2023第二季度IDL员工座谈会",url: require('@/assets/news/小图/68.png')},
        {id:67,date:"2023年7月10日",name:"不负韶华争朝夕，奋楫扬帆正当时，2023届大学生岗前培训结业仪式圆满落幕",url: require('@/assets/news/小图/67.png')},
        {id:66,date:"2023年7月4日",name:"“逐梦盛泰 扬帆起航”欢迎2023届新进大学生",url: require('@/assets/news/小图/66.png')},
        {id:65,date:"2023年7月3日",name:"消防技能大比武，筑牢安全防火墙——2023盛泰消防技能比武活动",url: require('@/assets/news/小图/65.png')},
        { id: 64, date: '2023年6月25日', name: '【盛泰资讯】重庆市政协主席唐方裕莅临盛泰光电科技股份有限公司参观调研', url: require('@/assets/news/小图/64.png') },
        { id: 63, date: '2023年6月17日', name: '“重庆市企业创新奖”出炉，盛泰光电科技股份有限公司榜上有名', url: require('@/assets/news/小图/63.png') },
        { id: 62, date: '2023年6月13日', name: '【盛泰团建】打造优秀团队，共创盛泰辉煌', url: require('@/assets/news/小图/61.png') },
        { id: 61, date: '2023年6月5日', name: '观念转换，科学推进——2023重庆公司六西格玛项目顺利启动', url: require('@/assets/news/小图/62.png') },
        { id: 60, date: '2023年6月5日', name: '【盛泰资讯】重庆市检察院检察长时侠联来盛泰公司调研', url: require('@/assets/news/小图/60.png') },
        { id: 59, date: '2023年6月2日', name: '“民生情怀浓 惠民更有感”关爱大足困难残疾人公益活动', url: require('@/assets/news/小图/59.png') },
        { id: 57, date: '2023年5月25日', name: '2023年“跃动篮球，绽放激情”盛泰光电夏季男子篮球赛完美收官！', url: require('@/assets/news/小图/57.png') },
        { id: 56, date: '2023年5月24日', name: '为未来深入合作奠定良好基础', url: require('@/assets/news/小图/56.png') },
        { id: 55, date: '2023年4月25日', name: '大足区委书记陈一清率队观摩盛泰光电“5G＋工业互联网”项目', url: require('@/assets/news/小图/55.png') },
        { id: 54, date: '2023年4月19日', name: '群星之秀，川流不息——2023年第一季度“盛泰之星”颁奖仪式圆', url: require('@/assets/news/小图/54.png') },
        { id: 53, date: '2023年4月8日', name: '重庆市经信委金融处王逸飞处长到盛泰座谈交流', url: require('@/assets/news/小图/53.png') },
        { id: 52, date: '2023年4月1日', name: '2023年第一季度IDL员工座谈会圆满结束', url: require('@/assets/news/小图/52.png') },
        
        { id: 50, date: '2023年3月28日', name: '重庆工商大学黄海燕老师一行来盛泰光电公司参观交流', url: require('@/assets/news/小图/50.png') },
        { id: 49, date: '2023年3月20日', name: '建绿色工厂 树绿色理想” 盛泰植树周活动', url: require('@/assets/news/小图/49.png') },
        { id: 48, date: '2023年3月18日', name: '盛泰光电受邀参加高通计算生态峰会', url: require('@/assets/news/小图/48.png') },
        { id: 47, date: '2023年3月17日', name: '联通（重庆）5G融合创新中心领导莅临盛泰考察', url: require('@/assets/news/小图/47.png') },
        { id: 46, date: '2023年3月4日', name: '盛泰光电荣获“民营企业十强”和“优秀民营企业家”两项殊荣', url: require('@/assets/news/小图/46.png') },

        { id: 45, date: '2023年2月6日', name: '精准对接，“爱心托管”解民忧', url: require('@/assets/news/小图/45.png') },
        { id: 44, date: '2023年2月3日', name: '人大代表实地走访企业 助力企业发展', url: require('@/assets/news/小图/44.png') },
        
        { id: 43, date: '2023年1月15日', name: '【盛泰资讯】慰问台胞送温暖 两岸联谊有温情', url: require('@/assets/news/小图/43.png') },
        { id: 42, date: '2023年1月14日', name: '卯兔迎新 新岁启封 | 盛泰光电新年礼品已送达', url: require('@/assets/news/小图/42.png') },
        { id: 41, date: '2023年1月13日', name: '技术赋能，匠心品质，实力呈现--盛泰光电荣获麦博韦尔双料大奖 ”', url: require('@/assets/news/小图/41.png') },
        { id: 40, date: '2023年1月12日', name: '盛泰光电荣获中兴通讯“2022年度质量优秀奖 ”', url: require('@/assets/news/小图/40.png') },
        { id: 37, date: '2023年1月8日', name: '与客户共谋可持续高质量发展，盛泰再次荣获传音控股“最具价值合作伙伴 “奖', url: require('@/assets/news/小图/37.png') },

        { id: 36, date: '2022年12月22日', name: '铆劲抓生产·打好“收官战”', url: require('@/assets/news/小图/36.png') },
        { id: 35, date: '2022年12月22日', name: '秋招季|高校宣讲会圆满收官，场场精彩', url: require('@/assets/news/小图/35.png') },
        { id: 34, date: '2022年12月5日', name: '盛泰活动|守护双桥生态·绿色环保盛泰行 捡拾活动顺利举行', url: require('@/assets/news/小图/34.png') },
        { id: 33, date: '2022年11月29日', name: '同心抗“疫”，感谢有你----致奋战在盛泰光电疫情防控一线全体勇士的感谢信', url: require('@/assets/news/小图/33.png') },
        { id: 32, date: '2022年11月27日', name: '青春无畏·逐梦扬威，盛泰光电2022年冬季职工篮球赛圆满结束', url: require('@/assets/news/小图/32.png') },
        { id: 31, date: '2022年11月26日', name: '同心“战”疫，共克时艰|爱护宿舍环境，从你我做起', url: require('@/assets/news/小图/31.png') },
        { id: 30, date: '2022年11月24日', name: '大足 盛泰光电入选国家知识产权优势企业', url: require('@/assets/news/小图/30.png') },
        { id: 29, date: '2022年11月15日', name: '盛泰光电举办“凝心聚力，向新征程”拔河比赛圆满结束', url: require('@/assets/news/小图/29.png') },
        { id: 28, date: '2022年10月27日', name: '创新是第一动力 人才是第一资源', url: require('@/assets/news/小图/28.png') },
        { id: 26, date: '2022年10月15日', name: '江西省人大常委会副主任张小平来江西盛泰精密光学有限公司开展调研', url: require('@/assets/news/小图/26.png') },
        { id: 25, date: '2022年9月13日', name: '2022年内部讲师交流会圆满举行', url: require('@/assets/news/小图/25.png') },
        { id: 21, date: '2022年9月6日', name: '盛泰资讯|吉林大学重庆研究院到盛泰光科走访交流', url: require('@/assets/news/小图/21.jpg') },
        { id: 23, date: '2022年8月30日', name: '盛泰资讯|盛泰光电上榜2022重庆制造业企业100强', url: require('@/assets/news/小图/23.jpg') },
        { id: 22, date: '2022年8月30日', name: '盛泰资讯|大足区组织部副部长、老干局局长张玛莉一行领导莅临我司调研', url: require('@/assets/news/小图/22.jpg') },
        { id: 20, date: '2022年8月30日', name: '盛泰资讯|盛泰光电捐资助学，情暖高升莘莘学子', url: require('@/assets/news/小图/20.jpg') },
        { id: 19, date: '2022年8月30日', name: '盛泰资讯|大足区经信委开展复工复产调研工作，访企业、听心声、问需求、话发展', url: require('@/assets/news/小图/19.jpg') },
        { id: 24, date: '2022年8月22日', name: '“悦享盛夏·鱼乐无穷”2022盛泰第一届“盛泰杯”钓王比赛圆满结束', url: require('@/assets/news/小图/24.png') },
        { id: 17, date: '2022年8月17日', name: '江西盛泰与英恒达成战略合作，共同推进中国智能汽车产业链发展', url: require('@/assets/news/小图/17.jpg') },
        { id: 16, date: '2022年7月20日', name: '第六届“渝创渝新”创业创新大赛决赛我司项目荣获大赛制造业组三等奖', url: require('@/assets/news/小图/16.jpg') },
        { id: 15, date: '2022年7月13日', name: '盛泰光电获“川渝聚力，创汇大足”创业创新大赛决赛第一名', url: require('@/assets/news/小图/15.jpg') },
        { id: 14, date: '2022年7月7日', name: '2022大足区新任处级领导干部一行参观我司', url: require('@/assets/news/小图/14.jpg') },
        { id: 13, date: '2022年7月5日', name: '盛泰资讯|盛泰光电成功跻身“2021重庆制造业民营企业100强”第28名', url: require('@/assets/news/小图/13.jpg') },
        { id: 11, date: '2022年6月25日', name: '盛泰资讯|成都市新津区税务局和商务会展局一行到访', url: require('@/assets/news/小图/11.jpg') },
        { id: 18, date: '2022年6月17日', name: '国际瑜伽日2022 | IDY2022 Curtain Raiser events continue in South China', url: require('@/assets/news/小图/18.png') },
        { id: 12, date: '2022年6月16日', name: '盛泰资讯|大足区人大常委机关离退休老干部一行莅临盛泰公司参观', url: require('@/assets/news/小图/12.jpg') },
        { id: 10, date: '2022年6月10日', name: '盛泰光电进入“中国创翼”创新创业大赛重庆赛区制造业专场10强', url: require('@/assets/news/小图/10.jpg') },
        { id: 9, date: '2022年6月7日', name: '团市委一行莅临公司参观考察', url: require('@/assets/news/小图/9.jpg') },
        { id: 1, date: '2022年5月12日', name: '喜讯！盛泰光电何阿强上榜“最美青年技能人才”', url: require('@/assets/news/小图/1.jpg') },
        { id: 2, date: '2022年2月21日', name: '杨烈常委一行莅临我司调研基层社会治理和平安建设工作', url: require('@/assets/news/小图/2.jpg') },
        { id: 3, date: '2022年1月12日', name: '以科技加持， 以可靠助力，盛泰公司可靠性实验分析中心剪彩仪式圆满举行', url: require('@/assets/news/小图/3.jpg') },
        { id: 4, date: '2021年11月5日', name: '重庆新闻联播到我司进行专题采访', url: require('@/assets/news/小图/4.jpg') },
        { id: 5, date: '2021年10月9日', name: '利剑出刃，2020年营收约30亿斩获2021重庆民营、制造双百强！', url: require('@/assets/news/小图/5.jpg') },
        { id: 6, date: '2021年10月9日', name: '赋能发展，砥砺前行，大足区区委书记陈一清调研重庆盛泰光电有限公司', url: require('@/assets/news/小图/6.jpg') },
        { id: 7, date: '2021年10月1日', name: '出货量全球第四！盛泰光电荣登人民日报头刊', url: require('@/assets/news/小图/7.jpg') },
       ],
      dataList: [],
      move_dataList: [],
      video_list: [
        { id: 1, title: '新闻资讯' },
        { id: 2, title: '盛泰映像' },
      ],
      video_data:[
        {id:1,url:`https://www.shine-optics.com/video/ows/yoga.mp4`,name:'国际瑜伽日 2022',title:'盛泰集团在6月的国际瑜伽日，组织一场迎接“世界瑜伽日”的活动，旨在让员工，放松身心，感受瑜伽的带给身体和心灵的福祉，远离都市疾病困扰。'},
        {id:2,url:`https://www.shine-optics.com/video/ows/overview.mp4`,name:'走进盛泰光电重庆总部',title:'盛泰光电在2006年7月成立于深圳，在成长壮大中于2018年4月成立重庆盛泰光电有限公司。公司一直保持快速增长，2020年实现产值36亿元，提供就业岗位2000余个；2021年产值超过40亿元，未来力争在3-4年内实现百亿产值。'},
        {id:3,url:`https://www.shine-optics.com/video/ows/autumn.mp4`,name:'金秋盛泰',title:'在追逐梦想的道路上，一定要记得驻足欣赏沿途的风景，盛泰的金秋，阳光温馨恬静，微风和煦轻柔，蓝天白云飘逸，正如盛泰人勤劳朴实的实干精神，谱写出洒满阳光，满载收获的秋季。'},
      ],
      video_id: 1,

    });
    let methods = {
      // 点击视频
      videoSpan(id) {
        state.video_id = id
      },
      routePush(id) {
        const href = router.resolve({ //使用resolve
          name: 'zhNewsId',    //这里是跳转页面的name
          path: '/zh/newsId',
          query: { id }
        })
        window.open(href.href, '_blank')
      },
      // pagesize改变触发
      handleSizeChange(val) {
        currentPage.value = 1
        pageSize.value = val
        state.dataList = state._dataList.slice(0, val)
      },
      // 当前页数改变触发
      handleCurrentChange(val) {
        window.scrollTo(0, 0)
        currentPage.value = val
        console.log('pagesize', val);
        //state._dataList，state.dataList是目前表格绑定的数据
        state.dataList = state._dataList.slice(
          (currentPage.value - 1) * pageSize.value,
          currentPage.value * pageSize.value
        );
      },
      setList() {
        let begin = (move_currentPage.value - 1) * move_pageSize.value;
        let end = move_currentPage.value * move_pageSize.value;
        state.move_dataList = [...state.move_dataList, ...state._dataList.slice(begin, end)];
        // state.move_dataList = data;
      }
    }
    onMounted(() => {
      let DATE = 1000
      total.value = state._dataList.length
      state.dataList = state._dataList.slice(0, 9)
      state.move_dataList = state._dataList.slice(0, 8)
      debounce(window.onscroll = () => {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        //滚动条到底部的条件(距底部20px时触发加载)

        if (
          scrollTop + windowHeight >= scrollHeight - 100
        ) {
          move_currentPage.value++
          methods.setList()
        }

      }, DATE)
      if (route.query && route.query.id == 2) {
        state.video_id = 2
      }
    })
    return {
      ...toRefs(state), ...methods, currentPage, pageSize, total, move_pageSize, move_currentPage
    };
  },
};
</script>

<style scoped lang="less">
.content_1:hover .imgs {
  transition: all 0.6s;
  transform: scale(1.03);

}

.box {
  width: 100%;

  .page_data {
    margin: 50px auto;
    max-width: 1920px;
    width: 70%;
    display: flex;

  }

  .content_button {
    margin: 50px auto;
    max-width: 1920px;
    width: 70%;

    .video {
      margin-left: 50%;
      transform: translateX(-50%);

      video {
        width: 800px;
      }
      p{
        width: 800px;
      }
    }
  }

  .content_top {

    margin: 50px auto;
    max-width: 1920px;
    width: 70%;
    height: 20px;

    .b_1 {
      float: right;
      margin-right: 50px;
      font-size: 1rem;

      span {
        cursor: pointer;
      }
    }

    .videoClass {
      border-bottom: 3px solid red;
      padding: 10px 0;
    }
  }

  .content {
    margin: 50px auto;
    max-width: 1920px;
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;

    .content_1 {
      flex: 1;
      position: relative;
      cursor: pointer;
      overflow: hidden;
      height: 350px;
      min-width: 30%;
      max-width: 24%;
      margin: 20px;
      border-radius: 8px 8px 0 0;
      background-color: #E9E9E9;
      overflow: hidden;

      .box {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 30px;

      }

      div {
        border-radius: 8px;
        overflow: hidden;
        height: 250px;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.6s;
      }

      img:hover {}

      p {
        padding: 0 20px;
        cursor: pointer;
      }

      p:hover {
        color: red;
        transform: scaleZ(2);
      }
    }
  }
}

::v-deep .el-card {
  border-radius: 8px;
}

::v-deep .el-carousel {
  max-width: 1920px;
  margin: 0 auto;
  overflow-y: hidden;
  height: auto;
  max-height: 600px;
  // max-height: 700px;
}

::v-deep .el-carousel__container {
  height: 100% !important;
  min-height: 500px;
}

.el-carousel {
  max-width: 1920px;
  margin: 0 auto;
}

::v-deep .el-card {
  border-radius: 8px;
}

.images {
  width: 100%;
  height: auto;
  max-height: 600px
}

// 小屏幕区域
@media only screen and (min-width: 767px) {
  .box {
    display: block;
  }

  ._div {
    display: none;
  }
}

@media only screen and (max-width: 767px) {
  .box {
    display: none;
  }

  ._div {
    display: block;
    overflow-x: hidden;

    .content {
      width: 100%;
      padding: 30px;
      display: flex;
      box-sizing: border-box;
      flex-wrap: wrap;

      .box_center:hover .pp {
        color: red;
      }

      .box_center {
        cursor: pointer;
        box-sizing: border-box;
        padding: 30px;
        flex: 1;
        max-width: 50%;
        min-width: 50%;
        height: 900px;

        img {
          width: 100%;
          height: 600px;
          border-radius: 15px;
          overflow: hidden;
        }

        .pp {
          position: relative;
          height: 240px;
          background-color: #E9E9E9;
          margin-top: -45px;
          padding-top: 30px;
          padding-left: 50px;
          padding-right: 20px;
          line-height: 60px;
          .p_2 {
            position: absolute;
            margin-top: -35px !important; 
            font-size: 35px;
            bottom: 0;
            color: #666;
          }
        }

      }
    }
  }
  .table_T{
    text-align: center;
    span{
      font-size: 3.75rem;
      cursor: pointer;
    }
  }
  .videoClass {
      border-bottom: 10px solid red;
      padding: 10px 0;
    }
    .content_button {
    margin: 50px auto;
      padding: 10px;
    .video {
      h2{
        font-size: 4rem;
      }
      p{
        font-size: 40px;
      }
      video {
        width: 100%;
      }
    }
  }
}
</style>